import { defineStore } from 'pinia'
import { computed, inject, ref } from 'vue'
import axios from 'axios'
import { BACKEND_BASEURL } from '@/config/config'
import { useSnackbarStore } from '@es-bill/es-bill-common-components'
import { useI18n } from 'vue-i18n'

export const useCommunitiesStore = defineStore('communitiesStore', () => {
  const { t } = useI18n()
  const $log = inject('log')
  const snackbarStore = useSnackbarStore()

  const communities = ref([])
  const communitiesLoading = ref(false)

  const allCommunities = computed(() => communities.value)
  const allCommunitiesLoading = computed(() => communitiesLoading.value)

  function postProcessCommunities(rawCommunities) {
    return rawCommunities.map((c) => {
      return {
        ...c,
        dateStart: c.dateStart ? new Date(c.dateStart) : undefined,
        dateEnd: c.dateEnd ? new Date(c.dateEnd) : undefined,
      }
    })
  }

  async function fetchCommunities() {
    communitiesLoading.value = true;
    communities.value = [];

    try {
      const response = await axios.get(BACKEND_BASEURL + 'metadata/communitiesCm');
      communities.value = postProcessCommunities(response.data);
      return response.data;
    } catch (error) {
      $log?.warn(error);
      snackbarStore.showSnackbar(t('connectionProblem'), '', 'Warning', 10000, []);
      throw error;
    } finally {
      communitiesLoading.value = false;
    }
  }

  function getCommunityByEcid(ecid) {
    return communities.value.find((community) => community.ecid === ecid) || null
  }

  // whole document update with __v concurrency check (ESB-638)
  async function updateCommunityByEcid(ecid, communityData) {
    const response = await axios.put(BACKEND_BASEURL + 'metadata/community/' + ecid, communityData);
    const index = communities.value.findIndex((c) => c.ecid === ecid);
    const processed = postProcessCommunities([response.data])[0];
    if (index !== -1) communities.value[index] = processed;
    return processed;
  }

  function getCommunity(ecn) {
    const matches = communities.value.filter((community) => community.ecn === ecn)
    if (matches.length > 0) return matches[0]
    return {
      id: 0,
      name: 'dlt',
      legal: 'dlt',
    }
  }

  return {
    // state
    allCommunities,
    allCommunitiesLoading,

    // actions
    fetchCommunities,
    getCommunity,
    getCommunityByEcid,
    updateCommunityByEcid,
  }
})


